<template>
  <div class="fo-layout-tpl">
    <div class="fo-layout-mode" :class="{'fo-layout-mode-wid': noWhite}">
      <div class="title-bar">
        <p class="primary title-alt"><slot name="alt"></slot></p>
        <h1 class="primary title"><slot name="title"></slot></h1>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    noWhite: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="less">
/* 移动 样式 */
@media screen and (max-width: 751px) and (min-width: 300px) {
  .fo-layout-tpl {
    width: 100%;
    height: 100%;
    .fo-layout-mode {
      height: 100%;
      padding: 40px 16px;
      .title-bar {
        font-family: Georgia, 宋体;
        text-align: center;
        .title-alt {
          font-size: 14px;
          margin: 0;
        }
        .title {
          font-size: 28px;
          font-weight: bold;
          margin: 0;
        }
      }
    }
    .fo-layout-mode-wid {
      width: 100%;
      max-width: 100%;
    }
  }
}
/* PC 样式 */
@media screen and (min-width: 751px) {
  @width: 80%;
  .fo-layout-tpl {
    width: 100%;
    height: 100%;
    .fo-layout-mode {
      width: @width;
      max-width: 1400px;
      height: 100%;
      padding: 80px 0;
      margin: auto;
      .title-bar {
        font-family: Georgia, 宋体;
        text-align: center;
        .title-alt {
          font-size: 16px;
          margin: 0;
        }
        .title {
          font-size: 4em;
          font-weight: bold;
          margin: 0;
        }
      }
    }
    .fo-layout-mode-wid {
      width: 100%;
      max-width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/compos/layoutMode.vue